import { Box, Chip, Stack, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import MapStyleSwitcher from '@/features/dashboard/map/overlays/MapStyleSwitcher'
import { blue, green, pink, purple, red } from '@/theme/colors'

export const OptionsMapStyle = (props) => (
    // const { onChange, value } = props

    (<Stack spacing={1} sx={{ display: 'block', m: 0, p: 0 }}>
        <Typography
            color="text.secondary"
            variant="overline"
            sx={{ display: 'block', mt: 4 }}
        >
            Map Style
        </Typography>
        <Stack alignItems="center" direction="row" flexWrap="wrap" gap={1}>
            <MapStyleSwitcher />
        </Stack>
    </Stack>)
)

// OptionsColorPreset.propTypes = {
//     onChange: PropTypes.func,
//     value   : PropTypes.oneOf(['blue', 'green', 'pink', 'purple', 'red'])
// }
